import type { MailUsFormValues } from "./support-types";

export const MAIL_US_LABEL = {
  SUBJECT: "Subject",
  MESSAGE_BODY: "Message Body",
  ATTACHMENT: "Attachment area (file should not exceed 5 MB)",
} as const;

export const MAIL_US_PLACEHOLDER = {
  SUBJECT: "Enter subject",
  MESSAGE_BODY: "Enter message",
} as const;

export const MAIL_US_ATTACHMENT_CTA = "Choose File";
export const MAIL_US_SUBMIT_LABEL = "Send";

export const MAIL_US_MESSAGE_MIN_ROWS = 4;
export const MAIL_US_ATTACHMENT_HEIGHT = "120px";
export const MAIL_US_ATTACHMENT_ACCEPT = "all";

export const MAIL_US_MAX_ATTACHMENT_SIZE_MB = 5;
export const MAIL_US_MAX_ATTACHMENT_SIZE_BYTES =
  MAIL_US_MAX_ATTACHMENT_SIZE_MB * 1024 * 1024;

export const MAIL_US_VALIDATION_MESSAGE = {
  SUBJECT_REQUIRED: "Subject is required",
  MESSAGE_REQUIRED: "Message is required",
  ATTACHMENT_SIZE: `File size must be less than ${MAIL_US_MAX_ATTACHMENT_SIZE_MB}MB`,
} as const;

export const MAIL_US_INITIAL_VALUES: MailUsFormValues = {
  subject: "",
  description: "",
  attachment: undefined,
};
